import application from 'application/application';

application.service('transformDate', [
	function() {
		this.formatDate = (date, calendar) => {
			if (!calendar) {
				var minuto = this.twoHouses(Math.round(date / 60));

				var formatado = new Date();

				formatado = formatado.setMinutes(formatado.getMinutes() + minuto);

				formatado = new Date(formatado);

				localStorage.setItem('__expires_in__', formatado);
			} else {
				var now = new Date();
				var expiryDate = new Date(now.getTime() + date * 1000);

				return expiryDate;
			}
		};

		this.twoHouses = number => {
			if (number <= 9) {
				number = '0' + number;
			}

			return number;
		};
	}
]);
